import { Modal } from '../Modal'
import React, { useEffect, useMemo, useState } from 'react'
import cl from 'classnames'
import styles from './Modal.module.scss'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Button, DataGridTable } from '@/ui'
import { NominationHeader } from '@features/nomination/NominationHeader'
import { generateData, nominationThunks } from '@/entity/nomination'
import { LoaderWrapper } from '@/components/Loader'


export const ViewModal = ({ onClose, item }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const [data, setData] = useState([])

	const { dictParams, dictValues } = useSelector((state) => ({
		dictParams: state.nomination.dictParams,
		dictValues: state.nomination.dictValues,
	}))

	useEffect(() => {
		let body = {
			data: { nominationCode: item?.nomination?.code },
			onSuccess: (res) => {
				let params = generateData(item?.paramValues, res, dictValues?.data)
				let sorted = params?.sort((a, b) => a?.orderNum > b?.orderNum ? 1 : -1)
				let result = sorted?.map(i => ({
					title: i.title,
					data: i.employer_data,
				}))
				setData(result)
			},
		}

		dispatch(nominationThunks.getDictParams(body))
	}, [])

	return (
		<Modal onClose={onClose}>
			<NominationHeader item={item}/>

			<div className={cl('py-4')}>
				<LoaderWrapper isLoading={dictParams.loading}>
					<DataGridTable
						hideSubTitle
						hideTitle
						hideCustomTitle
						information={data}
						titleClass={styles.tableTitleCell}
					/>
				</LoaderWrapper>
			</div>

			<div className={cl('flex', 'justify-content-end')}>
				<Button onClick={onClose}>
					{t('close')}
				</Button>
			</div>
		</Modal>
	)
}